/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".edit-item[_ngcontent-%COMP%]{font-size:18px!important}.edit-item[_ngcontent-%COMP%]::before{font-size:15px;float:left;margin-right:8px}"];
export { styles as styles };
